import { EMediaType } from '../types/gallery';
import { ICluster, IClusterSwiperOptions } from '../types/cluster';

export enum EClusterFeatureContainerClassName {
  Single = 'single',
  Triple = 'triple',
  Double = 'double',
}

export const CLUSTER_SWIPER_OPTIONS: IClusterSwiperOptions = {
  spaceBetween: 10,
  slidesPerView: 'auto',
};

export const clusters: ICluster[] = [
  {
    id: 'matveevsky',
    title: 'Матвеевский',
    description:
      'Матвеевский кластер — современный район, состоящий из четырёх проектов — «Новое Очаково», «Большая Очаковская 2», Vangarden и «Матвеевский парк», которые связаны друг с другом. Благодаря развитой инфраструктуре и благоустроенной территории жители кварталов будут наслаждаться комфортной жизнью, не тратя времени на поездки в другие районы.',
    /**
     * Вот тут нужно подумать над структурой, если не группировать, тогда нужно какую-то энамку с бэка получать или мапить на фронте.
     * Сейчас механика реализована на основе кол-во offers items, например для генплана один item ему проставляется класс single
     */
    features: [
      {
        id: 1,
        title: 'Генплан',
        offers: [
          {
            id: 2,
            title: 'Генплан',
            description:
              'В районе есть всё для спорта на свежем воздухе: здесь запланированы 3 км велодорожек, зоны для воркаута и площадки для командных видов спорта. Для детей предусмотрены современные игровые пространства. Владельцев четвероногих друзей порадует площадка для выгула собак.',
            thumbnailUrl:
              'https://cdn.cian.site/frontend/newbuilding-b2b-assets/images/pik/clusters/matveevsky/1/01.jpg',
            pins: [
              {
                name: 'Новое Очаково',
                url: 'https://zhk-novoe-ochakovo-i.cian.ru/',
                position: { top: '167px', right: '117px' },
              },
              {
                name: 'Большая Очаковская 2',
                url: 'https://zhk-bolshaya-ochakovskaya-2-i.cian.ru/',
                position: { top: '283px', left: '8px' },
              },
              {
                name: 'Матвеевский парк',
                url: 'https://zhk-matveevskiy-park-i.cian.ru/',
                position: { top: '424px', left: '150px' },
              },
              {
                name: 'Vangarden',
                url: 'https://zhk-vangarden-i.cian.ru/',
                position: { top: '231px', left: '410px' },
              },
            ],
            media: [
              {
                fullUrl:
                  'https://cdn.cian.site/frontend/newbuilding-b2b-assets/images/pik/clusters/matveevsky/1/02.jpg',
                thumbnailUrl: '',
                mediaType: EMediaType.Image,
              },
            ],
          },
        ],
      },
      {
        id: 5,
        title: '',
        offers: [
          {
            id: 6,
            title: '',
            description: '',
            thumbnailUrl:
              'https://cdn.cian.site/frontend/newbuilding-b2b-assets/images/pik/clusters/matveevsky/7/cover3.jpg',
            buttonTitle: 'Смотреть видео',
            hasVideoMedia: true,
            media: [
              {
                fullUrl:
                  'https://cdn.cian.site/frontend/newbuilding-b2b-assets/images/pik/clusters/matveevsky/7/about.mp4',
                thumbnailUrl: '',
                mediaType: EMediaType.Video,
              },
            ],
          },
          {
            id: 7,
            title: 'Пешеходный бульвар',
            description: `Вдоль Матвеевского кластера протянется широкий прогулочный бульвар. Он будет связан пешеходным мостом и создаст единую прогулочную зону вдоль всего кластера. Бульвар станет не только комфортным местом для прогулок, но и важным функциональным объектом, который свяжет проекты ПИК и инфраструктуру всего района. Концепцию благоустройства двухкилометрового бульвара с зонами озеленения около 4 га разработало британское бюро Gillespies.

            На бульваре можно будет гулять, заниматься спортом и играть с детьми. Здесь появятся современные игровые зоны для детей разных возрастов, которые позволят развиваться и знакомиться — мы построим их ближе к детским садам и школам. Также появятся места для спокойного и тихого отдыха — ближе к жилым домам.

            Бульвар отлично подойдёт для утренних пробежек. Вдоль него также протянутся велодорожки длиной 3 км. Весь путь будет непрерывным, в том числе по пешеходному мосту. Ещё на бульваре появится масштабная спортивная зона с площадками для воркаута и для командных видов спорта.

           В начале бульвара расположен вестибюль станции метро «Аминьевская», а также появится большой торговый центр. На первых этажах домов откроются магазины, кафе и полезные сервисы, которые мы заранее предусматриваем для комфорта жителей.
            `,
            thumbnailUrl:
              'https://cdn.cian.site/frontend/newbuilding-b2b-assets/images/pik/clusters/matveevsky/3/01.jpg',
            media: [
              {
                fullUrl:
                  'https://cdn.cian.site/frontend/newbuilding-b2b-assets/images/pik/clusters/matveevsky/3/01.jpg',
                thumbnailUrl: '',
                mediaType: EMediaType.Image,
              },
              {
                fullUrl:
                  'https://cdn.cian.site/frontend/newbuilding-b2b-assets/images/pik/clusters/matveevsky/3/02.jpg',
                thumbnailUrl: '',
                mediaType: EMediaType.Image,
              },
              {
                fullUrl:
                  'https://cdn.cian.site/frontend/newbuilding-b2b-assets/images/pik/clusters/matveevsky/3/03.jpg',
                thumbnailUrl: '',
                mediaType: EMediaType.Image,
              },
              {
                fullUrl:
                  'https://cdn.cian.site/frontend/newbuilding-b2b-assets/images/pik/clusters/matveevsky/3/04.jpg',
                thumbnailUrl: '',
                mediaType: EMediaType.Image,
              },
            ],
          },
          {
            id: 8,
            title: 'Фонтан на пешеходном бульваре',
            description: `Пешеходный бульвар Матвеевского кластера украсит сухой фонтан. У такого типа фонтанов нет традиционной чаши, а струи воды бьют прямо из тротуара, по которому можно гулять. Вместе они могут создавать разные водные эффекты: бегущие волны, фейерверки, выстрелы, взрывы. В вечернее время фонтан будет подсвечиваться разноцветными огнями.

           Рядом с фонтаном будет приятно отдыхать и взрослым, и детям со всего кластера, которые смогут играть с внезапно выстреливающими струями воды. В летние дни фонтан увлажняет воздух и спасает от жары. `,
            thumbnailUrl:
              'https://cdn.cian.site/frontend/newbuilding-b2b-assets/images/pik/clusters/matveevsky/4/01.jpeg',
            media: [
              {
                fullUrl:
                  'https://cdn.cian.site/frontend/newbuilding-b2b-assets/images/pik/clusters/matveevsky/4/01.jpeg',
                thumbnailUrl: '',
                mediaType: EMediaType.Image,
              },
            ],
          },
        ],
      },
      {
        id: 10,
        title: '',
        offers: [
          {
            id: 11,
            title: 'Пешеходный мост',
            description: `Новый пешеходный мост свяжет три жилых квартала: «Новое Очаково», «Матвеевский парк» и Vangarden. Мост соединит два пешеходных бульвара — так появится непрерывный прогулочный маршрут длиной два километра через скверы, кафе и магазины.

            Под самим мостом мы создадим общественное пространство: там появится небольшой зелёный парк с местами для отдыха. Здесь будет уютно и комфортно даже в самые жаркие дни или в непогоду: мост защитит от палящего солнца и дождя. В тёплое время года здесь можно будет встречаться с друзьями, проводить танцевальные вечеринки или занятия йогой на свежем воздухе.

            По мосту жителям будет удобно добираться до торгового центра и поликлиники в соседних проектах. Дорога до наших детских садов и школ станет безопаснее: чтобы дойти до них, детям не нужно будет переходить проезжую часть. Мост позволит с комфортом дойти от дома до метро «Аминьевская» и до станции будущего МЦД-4 «Очаково».

            У 350-метрового моста будет несколько лестниц, чтобы пешеходы могли подниматься и спускаться там, где им удобно: поближе к поликлинике, с бульваров или на середине моста. Каждая лестница дублируется пандусом — по нему будет легко вкатить детскую коляску.`,
            thumbnailUrl:
              'https://cdn.cian.site/frontend/newbuilding-b2b-assets/images/pik/clusters/matveevsky/2/01.jpeg',

            media: [
              {
                fullUrl:
                  'https://cdn.cian.site/frontend/newbuilding-b2b-assets/images/pik/clusters/matveevsky/2/01.jpeg',
                thumbnailUrl: '',
                mediaType: EMediaType.Image,
              },
            ],
          },
          {
            id: 13,
            title: 'Площадка для выгула собак',
            description: `На территории Матвеевского кластера появится DogHub — площадка для выгула собак. Можно спокойно отпустить питомца с поводка: здесь безопасно и для него, и для окружающих.

          На площадках установлены снаряды для тренировок и скамейки — хозяева могут тренировать собак и наблюдать за ними. А ещё это отличное место для социализации вашего питомца`,
            thumbnailUrl:
              'https://cdn.cian.site/frontend/newbuilding-b2b-assets/images/pik/clusters/matveevsky/6/01.jpeg',
            media: [
              {
                fullUrl:
                  'https://cdn.cian.site/frontend/newbuilding-b2b-assets/images/pik/clusters/matveevsky/6/02.jpg',
                thumbnailUrl: '',
                mediaType: EMediaType.Image,
              },
              {
                fullUrl:
                  'https://cdn.cian.site/frontend/newbuilding-b2b-assets//images/pik/clusters/matveevsky/6/03.jpg',
                thumbnailUrl: '',
                mediaType: EMediaType.Image,
              },
            ],
          },
        ],
      },
    ],
  },
];
